<template>
  <div class=" mb-10">
  <LoadingProgressBar/>
  <router-view/>
  <!--  Bottom Navigation Menu -->
  <nav v-if="!hideFooter" 
       class="flex fixed bottom-0 w-full justify-around p-2 pb-1 m10 bg-gray-900 text-gray-200 border-yellow-500 border-t text-center z-20">
    <div>
      <router-link :to="`/shop/${this.$store.getters.slug}/about`" >
        
        <span class="text-xs">{{ $t("about") }} </span>

      </router-link>
      <select class="left-8 bottom-0 h-8 absolute w-14 text-xs rounded-xl p-2 bg-gray-900 text-white text-center" v-model="this.$store.state.deflange" @change="onChange($event)">
              <option v-for="lang in this.$store.state.langes"
               :key="lang.id"
               :value="lang.id"
               >{{ lang.name }}
              </option>
       </select>
    </div>
  </nav>
  </div>
</template>

<script>
import LoadingProgressBar from "@/components/General/LoadingProgressBar.vue";
//import { getLanguages,getstorebyslug } from "@/API/API";
import store from './store';
//import { useStore } from 'vuex';
export default {
  name: "App",
  components: {
    LoadingProgressBar,
  },
  data() {
    return {
      notifications: [],
      selectedMainMenu:0,
      Languages: [],
      
    }
  },
  /*computed: {
  },*/
  async created() {
    //console.log('2001');
    //const store = useStore();
    /*let slug = 'rmmahryar'
    this.$i18n.locale = event.target.value;
    store.commit('SET_SLUG',slug );
    let st=(await getstorebyslug(slug)).data.result//this is for delete
    let templanguages=(await getLanguages(slug)).data.result
    //this.$store.langes=JSON.parse(JSON.stringify(templanguages))
    store.commit('SET_LANGES',JSON.parse(JSON.stringify(templanguages)) );
    console.log(JSON.parse(JSON.stringify(templanguages)))
    console.log(this.$store.state.langes)
    if(st.screenMenus.length >0)//this var move to store
       //this.$store.deflange=st.screenMenus[0].language.id;
       store.commit('SET_DEFLANGE',st.screenMenus[0].language.id );*/
       //this.$i18n.locale = ;
       //console.log(this.$route)
  },
  computed: {
    hideFooter() {
      // لیست صفحاتی که در آنها footer نباید نمایش داده شود
      const noFooterRoutes = ['/digitalmenu/','/choosedigitalmenu'];
      return noFooterRoutes.some(route => this.$route.path.includes(route));
    }
  },
  methods: {
    onChange: async function (event) {
      //console.log('1357')
      //console.log(event)
      //console.log(this.$route.params.id)
      //console.log(this.$route.name)
      //console.log(this.$route.params.slug) 
      if (this.$route.name === 'Menu')
      {
        //console.log(29)
        //console.log(`/shop/${this.$route.params.slug}/menu/${this.$route.params.id}`) 
        //this.$router.push(`/shop/${this.$route.params.slug}/about`)
        this.$i18n.locale = event.target.value;
        //console.log('123456123')
        //console.log(this.$i18n.locale)
        store.commit('SET_DEFLANGE',event.target.value );
        this.$router.push(`/shop/${this.$route.params.slug}/menu/${this.$route.params.id}`).then(() => { this.$router.go() })
      }
      if (this.$route.name === 'About') 
      {
        //console.log(3333)
        //console.log(event.target.value)
        this.$i18n.locale = event.target.value;
        //console.log(123456123)
        //console.log(this.$i18n.locale)
        store.commit('SET_DEFLANGE',event.target.value );
         this.$router.push(`/shop/${this.$route.params.slug}/about`).then(() => { this.$router.go() })
      }
      //this.selectedMenu= event.currentTarget.id;
      
      //console.log(`/shop/${this.$store.state.slug}/menu/${this.selectedMenu}`);
      //this.$router.push(`/shop/${this.$store.state.slug}/menu/${this.selectedMenu}`) 
    },
  }, 
      
    }
</script>
<style>
@font-face {
  font-family: 'iransans';
  src: url('assets/font/iran_sans.ttf');
}

* {
  -webkit-tap-highlight-color: transparent;
}

html, body {
  font-family: 'iransans' !important;
  direction: rtl;
  @apply bg-gray-900 text-gray-800
}

.router-link-active {
  @apply text-yellow-500
}

select:invalid {
  color: gray
}

/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}

.slide-enter-from {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(-100%, 0);
}
</style>
